import SdkTrack from "../Fwk/Kit/SdkTrack";
import DataMgr from "@/Fwk/DataMgr";

export default class EventTrack {
    static tag = `[EventTrack]`;

    //显示pwa页面时
    static ShowHome() {
        SdkTrack.track513Commit('pwa_s_land');
    }

    static ShowChromePWA() {
        SdkTrack.track513Commit('pwa_s_chrome');
    }

    static ShowDesktopPWA() {
        SdkTrack.track513Commit('pwa_s_desktop');
    }

    static ShowFacebookPWA() {
        SdkTrack.track513Commit('pwa_s_facebook');
    }

    //PWA落地页关闭时，落地页展示结束
    static ShowPwaEnd() {
        SdkTrack.track513Commit('pwa_s_land_end');
        this.trackNewUser('h5_newuser_pwa');
    }

    //点击pwa的安装时
    static ClickPwaInstall() {
        SdkTrack.track513Commit('pwa_c_download');
    }

    //触发 adjust初始化回调成功
    static TrackAdjustOk() {
        SdkTrack.track513Commit('pwa_adjust_init_sus');
    }

    //触发打开Chrome
    static TrackOpenChrome() {
        SdkTrack.track513Commit('pwa_open_chrome');
    }

    //进入游戏网页时
    static ShowGameWeb() {
        SdkTrack.track513Commit('pwa_game_s_land');
    }

    //进入游戏网页结束时
    static ShowGameWebEnd() {
        SdkTrack.track513Commit('pwa_game_s_land_end');
    }

    //加载unity资源时
    static ShowUnity() {
        SdkTrack.track513Commit('pwa_unity_load_start');
    }

    ////加载unity资源结束时
    static ShowUnityEnd() {
        SdkTrack.track513Commit('pwa_unity_load_end');
        this.trackNewUser('h5_newuser_unity');
    }

    static trackNewUser(key:string) {
        if (!DataMgr.hasKeySwitch(key)) {
            SdkTrack.track513Commit(key);
            DataMgr.setStorage(key, "1");
        }
    }

    //引导安装条展示时
    static leadInstallShow() {
        SdkTrack.track513Commit('lead_install_show');
    }

    //引导安装条自动消失时
    static leadInstallClose() {
        SdkTrack.track513Commit('lead_install_close');
    }

    //点击引导安装条，开始安装PWA时
    static clickLeadInstall() {
        SdkTrack.track513Commit('click_lead_install');
    }

    //点击落地页下载按钮时
    static clickPageInstall() {
        SdkTrack.track513Commit('click_page_install');
    }


}
